import { cn } from '@apps/web/lib/utils';

// The three disjoint outreach lanes the auto-outreach sections report on.
// Shared by the week-by-week comparison and the By Organization table so both
// filters stay in lockstep with the backend lane names.
export type OutreachLaneKey =
    | 'auto_drafted'
    | 'agent_outreach'
    | 'manual_outreach';

export const OUTREACH_LANE_OPTIONS: ReadonlyArray<{
    readonly key: OutreachLaneKey;
    readonly label: string;
}> = [
    { key: 'auto_drafted', label: 'Auto-drafted' },
    { key: 'agent_outreach', label: 'Agent outreach' },
    { key: 'manual_outreach', label: 'Manual outreach' },
];

export function LaneFilterChips({
    selected,
    onChange,
}: {
    readonly selected: ReadonlySet<OutreachLaneKey>;
    readonly onChange: (selected: Set<OutreachLaneKey>) => void;
}) {
    return (
        <div className="flex flex-wrap items-center gap-1">
            {OUTREACH_LANE_OPTIONS.map((option) => {
                const isSelected = selected.has(option.key);
                return (
                    <button
                        key={option.key}
                        type="button"
                        aria-pressed={isSelected}
                        onClick={() => {
                            const next = new Set(selected);
                            if (isSelected) {
                                // Keep at least one lane selected so the views
                                // never collapse to an empty table.
                                if (next.size === 1) {
                                    return;
                                }
                                next.delete(option.key);
                            } else {
                                next.add(option.key);
                            }
                            onChange(next);
                        }}
                        className={cn(
                            'rounded-md border px-2 py-1 text-xs font-medium',
                            isSelected
                                ? 'border-primary/50 bg-primary/10 text-foreground'
                                : 'text-muted-foreground bg-background hover:text-foreground',
                        )}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
